import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale());

export const schema = yup.object({
  code: yup.string(),
  claId: yup.number().required(t('max_buh.errors.claCodeRequired')),
  type: yup.string().required(t('max_buh.errors.claTypeRequired')),
  value: yup
    .number()
    .min(0)
    .max(9999.99)
    .typeError(t('max_buh.errors.maxBuhRequired'))
    .required(t('max_buh.errors.maxBuhRequired')),
  valid: yup.object({
    from: yup
      .date()
      .required(t('validationFieldRequired', { name: t('validFrom') }))
      .nullable()
      .default(null),
    to: yup
      .date()
      .nullable()
      .required(t('validationFieldRequired', { name: t('validTo') }))
      .default(null)
      .min(yup.ref<Date>('from'), t('max_buh.errors.validFromRequired'))
  })
});
